<template>
  <div
    class="field RMPE-CustomField"
    :class="{ 'RMPE-HasError': fieldHasError }"
  >
    <div class="control  has-icons-right">
      <label
        :for="fieldQuestionId"
        class="label"
      >
        <span
          :class="{'RMPE-Required': question.required}"
          v-html="question.label"
        />
        <div
          class="control"
          @dragover.prevent
          @drop="dragFile"
        >
          <label
            ref="auto-focus-target"
            tabindex="0"
            :for="fieldQuestionId"
            class="RMPE-FileUploadField-dropzone"
            @keydown.space.prevent="$refs['auto-focus-target'].click()"
          >
            <span class="icon is-small is-right"><font-awesome-icon :icon="icon" /></span>
            <span style="display: block">Drag and drop or click here to upload file.</span>
            <span style="display: block">Max file size is {{ question.options.maxFileSizeInMB }}MB</span>

            <span
              v-if="file !== null"
              class="RMPE-FileUploadField-dropzone-divider"
            />

            <span
              v-if="file !== null"
              style="display: block"
            >Selected file: <em>{{ file.name }}</em></span>
            <span
              v-if="file !== null"
              style="display: block"
            >File size: <em>{{ maxFileSizeAllowed(file.size) }}</em></span>
          </label>

          <input
            :id="fieldQuestionId"
            :ref="getFieldQuestionId()"
            type="file"
            class="input"
            :class="{ 'is-danger': fieldHasError }"
            autocomplete="off"
            :accept="acceptedFileTypes(question)"
            @change="handleFileUpload"
          >
        </div>
      </label>
    </div>
    <ErrorMessage
      v-if="fieldHasError"
      :errors="error.errors"
      :is-blurred="isBlurred"
      :manual-validate="manualValidate"
    />
    <HintMessage
      v-else
      :hint="question.warningMessage"
    />
  </div>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import FileUploadFieldMixin from '../common/file-upload-field';
import StaticFieldMixin from '../../mixins/static-field-mixin';

export default {
  components: { FontAwesomeIcon },
  mixins: [StaticFieldMixin, FileUploadFieldMixin],
};
</script>

<style scoped lang="scss">
.RMPE-FileUploadField-dropzone {
  //color: var(--form-font-color);
  padding: 10px 0px;
  text-align: center;
  display: block;
  border: 1px dashed;
  border-radius: 5px;
  cursor: pointer;
  &:hover,
  &:focus {
    border-color: transparent;
  }
}
.RMPE-FileUploadField-dropzone-divider{
  margin: 8px;
  border-top: var(--text-answer-color) 1px dotted;
  height: 1px;display: block
}
.control{
  margin-top: 0.5em!important;
}

input {
  display: none;
}
</style>
